import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { BitrateChart } from './BitrateChart';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

interface IBitrateChartsProps {
  audioBitrate: number[];
  labels?: string[];
  videoBitrate: number[];
}

const ChartBlock = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  background: '#fff',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  textAlign: 'center',
  paddingBottom: theme.spacing(3),
  border: '1px solid #ddd',
}));

const TitleSection = styled(Typography)(({ theme }) => ({
  fontSize: '17px',
  fontWeight: 600,
  borderBottom: '1px solid #ccc',
  padding: theme.spacing(1.5),
  textAlign: 'left',
}));

export const BitrateCharts = ({
  audioBitrate,
  labels,
  videoBitrate,
}: IBitrateChartsProps) => {
  return (
    <ChartBlock>
      <TitleSection>Quality call indicator</TitleSection>
      <Grid container={true} spacing={2}>
        <Grid item={true} md={6} xs={12}>
          <BitrateChart
            color="75,192,192"
            data={audioBitrate}
            labels={labels}
            lines={[5, 15, 25]}
            title="Audio Bitrate"
          />
        </Grid>
        <Grid item={true} md={6} xs={12}>
          <BitrateChart
            color="75,192,192"
            data={videoBitrate}
            labels={labels}
            lines={[200, 400, 600]}
            title="Video Bitrate"
          />
        </Grid>
      </Grid>
    </ChartBlock>
  );
};
